import React from 'react';
import { IntervalProperty } from './types';

type Props = {
  property: IntervalProperty;
};

export function IntervalPropertyValue({ property }: Props) {
  const { from, to, unit } = property;

  if (from === null && to === null) {
    return null;
  }

  const unitSuffix = unit === null ? '' : `\u00A0${unit}`;

  if (from === null) {
    return <>{`${to}${unitSuffix}`}</>;
  }

  if (to === null || from === to) {
    return <>{`${from}${unitSuffix}`}</>;
  }

  return <>{`${from}\u00A0-\u00A0${to}${unitSuffix}`}</>;
}
